type LayoutProps = {
  children: React.ReactNode;
  fullHeight?: boolean;
  noPadding?: boolean;
};

import classNames from 'classnames';
import styles from './styles.module.css';

export const Layout = ({ children, fullHeight = false, noPadding = false }: LayoutProps) => {
  const mainStyles = classNames(styles.main, {
    [styles.fullHeight]: fullHeight,
    [styles.noPadding]: noPadding,
  });
  return (
    <div className={styles.pageLayout}>
      <div className={mainStyles}>{children}</div>
    </div>
  );
};
